var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowTopRightLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0659 14.175C22.0659 12.8624 23.1299 11.7983 24.4425 11.7983H44.6092C45.9218 11.7983 46.9858 12.8624 46.9858 14.175V34.3416C46.9858 35.6542 45.9218 36.7183 44.6092 36.7183C43.2966 36.7183 42.2325 35.6542 42.2325 34.3416V19.9128L16.0398 46.1055C15.1116 47.0337 13.6068 47.0337 12.6787 46.1055C11.7505 45.1774 11.7505 43.6726 12.6787 42.7444L38.8714 16.5517H24.4425C23.1299 16.5517 22.0659 15.4876 22.0659 14.175Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopRightLarge);
export default __webpack_public_path__ + "static/media/arrow-top-right-large.4c34e60dcdf840c5ca1ec52b63597fbe.svg";
export { ForwardRef as ReactComponent };